module.exports = __webpack_public_path__ + "static/media/lock-manage.b2bdfeaa.svg";